import type {Concept, EntityMainType} from 'types';
import {EntityMainTypes} from 'types';

export const isEntityMainType = (
  entity: Concept | undefined,
): entity is EntityMainType => {
  return !!entity && EntityMainTypes.includes(entity as EntityMainType);
};
